<template>
<div class="state-selector-widget">
    <div class="state-selector-button" v-if="stateSelectorVisible === true">
        <div @click="states_visible = !states_visible" class="click-to-filter filter-button">
            <div></div>
            <div v-if="['entrepreneurship','realclearunicorns'].indexOf(issue.slug) === -1" >Click to Filter</div>
            <div v-else >Click to Select</div>
            <div style="width: 1rem"><span v-if="states_visible">&times;</span></div>
        </div>
        <div v-show="states_visible" class="filter-input">
            <div class="triangle"></div>
            <div class="states-wrapper">
                <div v-if="tagsSelectorVisible" class="category-column">
                    <div class="column-title">Category</div>
                    <div class="tag-wrapper tags">
                        <label v-for="tag in tags" :key="tag.id" class="select-tag-label" :class="{ 'selected-tag' : tag.checked}">
                            <input @change="pushUpChange()" type="checkbox" 
                                :key="tag.slug + '_state'" name="select-tag" v-model="tag.checked" 
                                :true-value="true" :false-value="false"><span v-html="tag.name" ></span>
                        </label>
                    </div>
                </div>
                <div v-if="stateSelectorVisible" class="state-column">
                    <div class="column-title">State</div>
                    <div class="tag-wrapper states">
                        <label v-for="state in states" :key="state.id" class="select-tag-label" :class="{ 'selected-tag' : state.checked}">
                            <input @change="pushUpChange()" 
                                :key="state.slug" type="checkbox" name="select-tag" 
                                v-model="state.checked" :true-value="true" :false-value="false" />
                            <span class="state_name">{{state.name}}</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="two-col-wrapper filter-input">
        <div class="filter-line"></div>
        <div class="filter-input-label-wrapper">
            <div v-if="['entrepreneurship','realclearunicorns'].indexOf(issue.slug) === -1" class="filter-input-label" >Click to Filter</div>
            <div v-else class="filter-input-label" >Click to Select</div>
        </div>
        <div class="filter-input-wrapper checkbox-input">
            <label v-for="tag in tags" :key="tag.id" class="select-tag-label tags" :class="{ 'selected-tag' : tag.checked}">
                <input @change="pushUpChange()" type="checkbox" name="select-tag" v-model="tag.checked" :true-value="true" :false-value="false">
                <span>{{tag.name}}</span>
            </label>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'filter-posts',
    props: {
        issue: {
            type: [Array, Object],
            default: function(){
                return [];
            },
        },

        posts: {
            type: Array,
            default: function(){
                return [];
            },
        },

        sections: {
            type: Array,
            default: function(){
                return [];
            },
        },

        tagsSelectorVisible: {
            type: Boolean,
            default: false,
        },

        stateSelectorVisible: {
            type: Boolean,
            default: false,
        },

        tags: {
            type: Array,
            default: function(){
                return [];
            },
        },

        states: {
            type: Array,
            default: function(){
                return [];
            },
        },
    },
    data: function () {
        return {
            states_visible: true
        }
    },
    created() {
    },
    computed: {

        selected_tags: function () {

            return this.tags.filter(function (tag) {

                if (tag.checked == true) {
                    return tag;
                }

            })
        },
        
        selected_states: function () {

            return this.states.filter(function (state) {

                if (state.checked == true) {
                    return state;
                }

            })
        },

        updatedSections(){

            // break reactivity for these properties
            let sections = JSON.parse(JSON.stringify(this.sections));
            let posts = JSON.parse(JSON.stringify(this.posts));

            // loop sections and clear out the posts array
            for (let i = 0; i < sections.length; i++) {
                let s = sections[i];
                s.posts = [];

                // loop the posts and match them up to the section
                for (let x = 0; x < posts.length; x++) {
                    let post = posts[x];
                    let add_post = true;

                    // if not part of this section don't even botha
                    if(typeof post.public_affairs_section_id == 'undefined' || post.public_affairs_section_id !== s.id){
                        add_post = false;
                    }

                    // match up post to selected tags, if any
                    if(add_post == true && this.selected_tags.length > 0 ){

                        if( post.tags.length == 0 ){
                            
                            add_post = false;

                        }else{

                            for (let z = 0; z < this.selected_tags.length; z++) {

                                let tag = this.selected_tags[z];

                                let index = post.tags.map(t => t.id).indexOf(tag.id);

                                if (index == -1) {
                                    add_post = false;
                                    break;
                                }
                            }
                        }
                    }

                    // match up posts to selected states, if any
                    if(add_post == true && this.selected_states.length > 0 ){

                        if( post.states.length == 0 ){
                            
                            add_post = false;

                        }else{

                            for (let z = 0; z < this.selected_states.length; z++) {

                                let state = this.selected_states[z];

                                let index = post.states.map(s => s.id).indexOf(state.id);

                                if (index == -1) {
                                    add_post = false;
                                    break;
                                }
                            }
                        }
                    }

                    // and finally, if everything goes well, push to the section
                    if(add_post){
                        s.posts.push(post);
                    }
                    
                }

                // replace the section
                sections[i] = s;
            }

            // return the new sections instance
            return sections;
        },

    },
    methods: {

        /**
         * Pushes up the sections change after the filter has done it's work
         */
        pushUpChange(){
            this.$nextTick(() => {
                // console.log("PUSH UP CHANGE", this.updatedSections);
                this.$emit('posts-filtered', this.updatedSections);
            });
        },

    },
}
</script>